// @flow

import { observer } from "mobx-react";
import * as React from "react";

import "./Panel.scss";

type Props = {
    children: React.Node,
    className?:
        | "default"
        | "primary"
        | "success"
        | "info"
        | "warning"
        | "danger",
    header?: any,
    footer?: any
};

@observer
export default class Panel extends React.Component<Props> {
    render() {
        const className = this.props.className || "default";

        return (
            <div className={"panel panel-" + className}>
                {this.renderHeader()}
                <div className="panel-body">{this.props.children}</div>
                {this.renderFooter()}
            </div>
        );
    }

    renderHeader() {
        if (!this.props.header) {
            return null;
        }

        return <div className="panel-heading">{this.props.header}</div>;
    }

    renderFooter() {
        if (!this.props.footer) {
            return null;
        }

        return <div className="panel-footer">{this.props.footer}</div>;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Panel/Panel.js